import React from 'react';
import { IoMdRefresh } from 'react-icons/io';

const RefreshButton = ({ onClick, loader }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={loader}
            style={{
                background: 'transparent',
                border: '1px solid #ccc',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: loader ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                opacity: loader ? 0.6 : 1,
            }}
            onMouseOver={(e) => {
                if (!loader) {
                    e.currentTarget.style.borderColor = '#888';
                    e.currentTarget.style.color = '#333';
                }
            }}
            onMouseOut={(e) => {
                if (!loader) {
                    e.currentTarget.style.borderColor = '#ccc';
                    e.currentTarget.style.color = '#666';
                }
            }}
            title="Refresh"
        >
            <IoMdRefresh size={20} />
        </button>
    );
};

export default RefreshButton;
